export const en = {
    dayBudgetMode: 'Display mode',
    perDay: 'per day'
};
